import React from 'react'
import { PrismicLink, PrismicRichText } from '@prismicio/react'

const Steps = ({ slice }) => {
  return (
    <section className='component-steps bg-brand-orange'>
      <div className='mx-auto w-full max-w-screen-xl p-6 md:py-16'>
        <div className='prose prose-invert prose-xl max-w-none text-center mb-10'>
          <PrismicRichText field={slice.primary.title.richText} />
          <PrismicRichText field={slice.primary.text.richText} />
        </div>
        <ol className='flex flex-col md:flex-row justify-between list-none mb-4'>
          {slice.items.map((step, index) => {
            return (
              <li className={`step flex flex-row md:block md:text-center relative pb-2 flex-1 ${step.step_link && 'group'}`} key={`step-${index}`}>
                <div className='flex flex-row md:justify-center mb-2 md:mb-8 relative z-10'>
                  <span className='flex items-center font-black justify-center text-brand-orange bg-white group-hover:scale-105 transition duration-150 ease-in-out rounded-full p-2 text-3xl h-16 w-16 md:h-20 md:w-20'>
                    {index + 1}
                  </span>
                </div>
                <div className='ml-4 md:px-16 md:ml-0 prose lg:prose-lg prose-invert'>
                  <h3 className='mb-0'>{step.step_title}</h3>
                  <p>{step.step_text}</p>
                  {step.step_link?.url && (
                    <PrismicLink className='link group-hover:text-white' field={step.step_link}>
                      Read more
                    </PrismicLink>
                  )}
                </div>
              </li>
            )
          })}
        </ol>
      </div>
    </section>
  )
}

export default Steps
